import React, { useContext, ReactNode } from 'react';

export interface XdmSettings {
  baseUrl: string;
  headers: { key: string; value: string }[];
}

export interface ConfigApiState {
  apiBaseUrl: string;
  apiPath: string;
  headers: { key: string; value: string }[];
  xdmSettings: XdmSettings;
}

export const ConfigApiContext = React.createContext<ConfigApiState>({} as any);

interface Props {
  children?: ReactNode;
  initialState?: ConfigApiState;
}

export const ConfigApiProvider: React.FC<Props> = ({
  children,
  initialState = {
    apiPath: '',
    apiBaseUrl: '',
    headers: [],
    xdmSettings: {
      baseUrl: '',
      headers: [],
    },
  },
}) => {
  return (
    <ConfigApiContext.Provider value={initialState}>
      {children}
    </ConfigApiContext.Provider>
  );
};

export const useConfigApiContext = () => useContext(ConfigApiContext);
